export const CONTEXT_DATA_EVENT = 'context-data';
export const GTM_START = 'gtm.start';
export const GTM_START_EVENT = 'gtm.js';

export interface GtmStartEventData {
  consultantId: number;
  customerId: number;
  customerTypeId: number;
  event: typeof CONTEXT_DATA_EVENT | typeof GTM_START_EVENT;
  [GTM_START]: number;
  periodId: string;
  rewardPoints: number | null;
  signUpDate: string;
  visitorSegment: number;
}
